export default function() {
  $('#modal-delete-event').on('show.bs.modal', function (e) {
    var link = $(e.relatedTarget);
    $(this).find('form').attr('action', link.data('action'));
  });
};



// WEBPACK FOOTER //
// ./assets/js/subscriptions/delete.js